export default {
  userInfo: {},
  serviceInfo: {},
  freeRight: 0
}
